// extracted by mini-css-extract-plugin
module.exports = {"container":"post-detail_container__MlxGs"};